import { createStore } from "./_createStore";

type SearchState = {
  value: string;
  scope: string;
  setSearchOptions: (
    options: Partial<Omit<SearchState, "setSearchOptions">>,
  ) => void;
  resetSearch: () => void;
};

export const useSearchStore = createStore<SearchState>(
  (set) => ({
    value: "",
    scope: "",
    setSearchOptions: (options) => set(options),
    resetSearch: () => set({ value: "", scope: "" }),
  }),
  "SearchStore",
);
